// utils/logger.js
import type {ConsolaInstance, ConsolaOptions} from 'consola'
import {createConsola} from 'consola'

// 환경에 따른 기본 설정
const isProd = process.env.NODE_ENV === 'production'

// 기본 로거 생성
export const logger = createConsola({
  level: isProd ? 3 : 5,  // production: 3 (중요 로그만), development: 5 (모든 로그)
  fancy: !isProd,
})

// 로거 내보내기

export function useLogger(tag?: string, options: Partial<ConsolaOptions> = {}): ConsolaInstance {
  return tag ? createConsola({
    level: isProd ? 3 : 5,  // production: 3 (중요 로그만), development: 5 (모든 로그)
    fancy: !isProd,
    ...options,
  }).withTag(tag) : logger
}
